import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
export default function CallSummary() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="summary">고객과 통화 중 중요한 키워드만 쏙쏙, 요약 정리해줘요</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<div className="group_view"><Image className="img_guide" src="/image/mobile/popup/call02_01.png" alt={"\uACE0\uAC1D\uACFC \uD1B5\uD654 \uC911 \uC911\uC694\uD55C \uD0A4\uC6CC\uB4DC\uB9CC \uC3D9\uC3D9, \uC694\uC57D \uC815\uB9AC\uD574\uC918\uC694"} width={100} height={100} /></div></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}